<template>
  <div>
    <RequiredText />
    <Input
        :name="`${id}-name`"
        :label="$t('crm.label.label')"
        :placeholder="$t('crm.label.label')"
        v-model="formData.title"
    />
    <Select2
        :parent-id="`#${id}`"
        :multiple="false"
        :name="`${id}-action-type`"
        :label="$t('crm.label.type')"
        :placeholder-text="$t('crm.label.select_type')"
        v-model="formData.type"
    >
      <option v-for="(type, index) in emailActivityTypeEnum" :value="type.value" :key="index" >
        {{ type[locale] }}
      </option>
    </Select2>
    <div class="row">
      <InputDate2
          container-class="col-6"
          :name="`${id}-call-date`"
          :label="$t('crm.label.date')"
          v-model="formData.date"
          :placeholder="$t('crm.label.date')"
      />
      <Input
          container-class="col-6"
          type="time"
          :name="`${id}-call-time`"
          :label="$t('crm.label.time')"
          v-model="formData.time"
          :placeholder="$t('crm.label.time')"
      />
    </div>
    <div v-if="false" class="d-flex align-items-center my-5">
      <label :for="`${id}-name`" class="form-label required me-5 col-1"> De</label>
      <Input
          container-class="col-7"
          :name="`${id}-name`"
          v-model="formData.title"
      />
      <div class="d-flex gap-2 ms-auto">
        <button class="btn btn-sm btn-flex btn-bg-white text-primary fw-bolder shadow-sm rounded-3 border border-secondary px-3 py-4 fs-9">
          <i class="fa fa-plus text-primary">  </i>
          Cc
        </button>
        <button class="btn btn-sm btn-flex btn-bg-white text-primary fw-bolder shadow-sm rounded-3 border border-secondary px-3 py-4 fs-9">
          <i class="fa fa-plus text-primary">  </i>
          Cci
        </button>
        <button class="btn btn-sm btn-flex btn-bg-white text-primary fw-bolder shadow-sm rounded-3 border border-secondary px-3 py-4 fs-9">
          <i class="fa fa-plus text-primary"> </i>
          Faire suivre à
        </button>
      </div>
    </div>
    <div v-if="false" class="d-flex align-items-center my-5">
      <label :for="`${id}-to`" class="form-label text-uppercase required me-5 col-1"> à</label>
      <Input
          container-class="col"
          :name="`${id}-to`"
          v-model="formData.title"
      />
    </div>
    <div v-if="false" class="d-flex align-items-center my-5">
      <label :for="`${id}-subject`" class="form-label required me-5 col-1"> Sujet</label>
      <Input
          container-class="col"
          :name="`${id}-subject`"
          v-model="formData.title"
      />
    </div>
    <Select2
        :parent-id="`#${id}`"
        :multiple="false"
        :name="`${id}-call-priority`"
        :label="$t('crm.label.priority')"
        :placeholder-text="$t('crm.label.select_priority')"
        v-model="formData.priority"
    >
      <option v-for="(priority, index) in opportunityPriorityEnum" :value="priority.value" :key="index" >
        {{ priority[locale] }}
      </option>
    </Select2>
    <div class="row" v-show="past">
      <label class="form-label">{{ $t('appointments.label.reminder') }}</label>
      <div class="input-group">
        <Input
            containerClass="form-group col-3 col-md-3 col-lg-3 mt-auto mb-5"
            :name="`frequence_number`"
            type="number"
            :min="0"
            :inputClass="'form-control form-control-lg form-control-solid'"
            :isRequired="false"
            :placeholder="$t('appointments.label.placeholder_reminder_number')"
            v-model="formData.remind_frequency_count"
        />
        <Select2
            :parent-id="`#${id}`"
            container-class="form-group col-9 col-md-9 col-lg-9 mt-auto mb-5"
            :multiple="false"
            :show-search="true"
            :selectClass="'form-select form-control-sm form-select-solid'"
            :name="`reminder`"
            :isRequired="false"
            :placeholder-text="$t('appointments.label.placeholder_reminder')"
            v-model="formData.remind_frequency"
        >
          <option v-for="(item, index) in frequencyEnum" :key="index" :value="item.value">
            {{ item[locale] }}
          </option>
        </Select2>
      </div>
    </div>
  </div>
</template>

<script setup>
import {computed, ref, defineProps, onMounted, watch} from "vue";
import Input from "@/components/Input.vue";
import {useStore} from "vuex";
import RequiredText from "@/components/RequiredText"
import InputDate2 from "@/components/InputDate2.vue"
import Select2 from "@/components/Select2.vue"
import Button from "@/components/Button.vue";
import {useLocales} from "@/composables/locales";
import {compareDateToToday} from "@/mixins/Helpers"

const store = useStore()
const props = defineProps({
  form: {
    type: Object,
    required: true
  },
  id: {
    type: String,
    required: true
  }
})
const { locale } = useLocales()

const formData = ref(props.form)

watch(() => props.form, (value) => {
  formData.value = value
})

const emailActivityTypeEnum = computed(() => store.getters['activity/emailActivityTypeEnum'])
const opportunityPriorityEnum = computed(() => store.getters['pipelines/pipelinePriorityEnum'])
const frequencyEnum = computed(() => store.getters["pipelines/getActivityRemindEnum"])
const past = computed(() => {
  let datetime = formData.value.date + ' ' + formData.value.time
  return compareDateToToday(formData.value.date+' 00:00') || compareDateToToday(datetime)
})
</script>

<style scoped>

</style>
